// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-button-container {
  position: relative;
}

.dropdown-content {
  position: absolute;
  top: 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid var(--theme-main-border-color, #055C8D);
  background-color: #ffffff;
  font-family: Inter;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 12px !important;
  text-align: left;
}

.dropdown-button-content-list {
  list-style-type: none;
  padding: 0 8px;
  margin: 4px;
}

.dropdown-button-content-list-item {
  cursor: pointer;
}

.dropdown-button-content-list-item-disabled {
  color: #999999 !important;
}

.dropdown-button-content-list-item:hover {
  color: var(--theme-main-color, #055C8D) !important;
  font-weight: 300 !important;
}

.primary {
  background: var(--theme-main-background-color, #055C8D);
  border-radius: 5px;
  outline: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.331373px;
  color: #FFFFFF;
  border: none;
  width: -moz-fit-content;
  width: fit-content;
  height: 34px;
  white-space: nowrap;
  min-width: 80px;
}

.secondary {
  background: rgb(255, 255, 255);
  border-radius: 5px;
  outline: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.331373px;
  color: var(--theme-main-color, #055C8D);
  border: 1px solid var(--theme-main-border-color, #055C8D);
  width: -moz-fit-content;
  width: fit-content;
  height: 34px;
  white-space: nowrap;
  min-width: 80px;
}

button.focus {
  outline: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
